export const COPY_INTERACTION_TIME = 1000;
export const INTERACTION_TIME = 1000;

export const PermissionsEnum = {
  USER_ADD: "USER_ADD",
  USER_EDIT: "USER_EDIT",
  USER_DELETE: "USER_DELETE",
  SETTINGS_IDEAS: "SETTINGS_IDEAS",
  SETTINGS_ROLES: "SETTINGS_ROLES",
  SETTINGS_GROUPS: "SETTINGS_GROUPS",
  DATASTORE_CREATE: "DATASTORE_CREATE",
  DATASTORE_EDIT: "DATASTORE_EDIT",
  SECURITY_VIEW: "SECURITY_VIEW",
  USER_ROLE_EDIT: "USER_ROLE_EDIT",
};

export const RolesEnum = {
  OWNER: "Owner",
  ADMIN: "Admin",
  USER: "User",
  OWNER_READ_ONLY: "Owner (Read Only)",
};

export const TIME_PERIODS = [
  {
    label: "Last Day",
    period: 1,
  },
  {
    label: "Last Week",
    period: 7,
  },
  {
    label: "Last Month",
    period: 30,
  },
  {
    label: "Last 3 Months",
    period: 90,
  },
  {
    label: "Last 6 Months",
    period: 180,
  },
];

// Values are SuperTokens `thirdPartyId`s and must match the backend's
// ConfigureProvider enum exactly — they key both the provider config written to
// SuperTokens and the group-fetch dispatch in sso_group_providers.py.
export const SSOProvider = {
  OKTA: "okta",
  ACTIVE_DIRECTORY: "active-directory",
  // Add more providers here as needed
} as const;

export type SSOProviderValue = (typeof SSOProvider)[keyof typeof SSOProvider];

// Customer-facing names. The provider id is an implementation detail, so it is
// never shown as-is: "active-directory" reads as "Azure AD" to the admin
// configuring it. Total over SSOProviderValue: adding a provider without a
// label is a compile error, not a silent "SSO" fallback in the UI.
export const SSOProviderLabel: Record<SSOProviderValue, string> = {
  [SSOProvider.OKTA]: "Okta",
  [SSOProvider.ACTIVE_DIRECTORY]: "Azure AD",
};

// Type predicate: callers that pass the check get a narrowed provider value,
// so downstream code needs no re-validation or fallback.
export const isValidSSOProvider = (provider: string): provider is SSOProviderValue => {
  return (Object.values(SSOProvider) as string[]).includes(provider);
};

// Privacy levels
export const Privacy = {
  PRIVATE: "private",
  PUBLIC: "public",
  // Owner plus everyone named in the workspace's grant list. Workspaces only —
  // knowledge sources, notebooks and query bookmarks stay two-state.
  RESTRICTED: "restricted",
};

// Screen breakpoints
export const SMALL_SCREEN_BREAKPOINT = 1440;
export const MOBILE_SCREEN_BREAKPOINT = 768;

export const DATABRICKS_STATUS_COLORS = {
  success: "#4CAF50",
  error: "#F44336",
  warning: "#FF9800",
} as const;
